import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { Tags } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

type Status = WintSuperkollAPIModel.MonthlyReportStatus;
const Status = WintSuperkollAPIModel.MonthlyReportStatus;

const appearance: Record<Status, { tagClass: string; text: string }> = {
  [Status.Generating]: {
    tagClass: cssExports.yellowTag,
    text: TranslationKeys.Advisor.MonthlyReportStatus_Generating,
  },
  [Status.Draft]: {
    tagClass: cssExports.blueTag,
    text: TranslationKeys.Advisor.MonthlyReportStatus_Draft,
  },
  [Status.Failed]: {
    tagClass: cssExports.redTag,
    text: TranslationKeys.Advisor.MonthlyReportStatus_Failed,
  },
  // ApprovedForCustomer covers the service's Approved and Sent; Published is the separate state
  // once it has actually gone out. Both mean the same thing to the advisor — the customer can read
  // it — so both read as "Godkänd" and both offer Unpublish rather than Approve.
  [Status.ApprovedForCustomer]: {
    tagClass: cssExports.greenTag,
    text: TranslationKeys.Advisor.MonthlyReportStatus_Approved,
  },
  [Status.Published]: {
    tagClass: cssExports.greenTag,
    text: TranslationKeys.Advisor.MonthlyReportStatus_Approved,
  },
  // The report service reported a state this API does not know yet. Core shows the row rather than
  // failing the page, so it needs a face here too: neutral, and none of the actions apply to it.
  [Status.Unknown]: {
    tagClass: cssExports.grayTag,
    text: TranslationKeys.Advisor.MonthlyReportStatus_Unknown,
  },
};

export const isSharedWithCustomer = (status: Status) =>
  status === Status.ApprovedForCustomer || status === Status.Published;

const MonthlyReportStatusTag: React.FC<{ status: Status }> = ({ status }) => (
  <Tags
    tags={[LocalizationHelperInstance.getFormattedMessage(appearance[status].text)]}
    className={appearance[status].tagClass}
  />
);

export default MonthlyReportStatusTag;
